export const correspondanceEmails = [
    { textValue: 'ma@sosinternational.nl'},
    { textValue: 'costcontrolteam@sosinternational.nl'},
    { textValue: 'medical-team@sosinternational.nl'},
    { textValue: 'MedischAdviseurs@sosinternational.nl'},
    { textValue: 'proformainvoice@sosinternational.nl'},
    { textValue: 'regresmed@sosinternational.nl'},
    { textValue: 'czexpat@sosinternational.nl'},
    { textValue: 'Disputenmedisch@sosinternational.nl'},
    { textValue: 'expats@sosinternational.nl'},
  ];  